module.exports = __webpack_public_path__ + "e3596c298f9216c31e3eb2e5773d13fd.pdf";